import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import weekday from "dayjs/plugin/weekday";
import quarterOfYear from "dayjs/plugin/quarterOfYear";

export class DayjsManager {
  constructor() {
    this.initializePlugins();
  }

  private initializePlugins(): void {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(isBetween);
    dayjs.extend(weekday);
    dayjs.extend(quarterOfYear);
  }

  getInstance() {
    return dayjs;
  }
}
